import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Datagrid from '../ui/Datagrid';
import { gridClasses } from '@mui/x-data-grid';
import columns from './table_config';
import { listMarketplaceLogs } from '../../store/actions/marketplaceLogs';
import { Grid, TablePagination } from '@mui/material';
import { renderCell } from '../ui/Datagrid/table_config';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { REDUX_ACTIONS } from '../../shared/config/constants';

// eslint-disable-next-line react/prop-types
function CustomPagination({ currentPage, limit, totalCount, handlePagination, loading }) {
  return (
    <TablePagination
      component="div"
      count={totalCount}
      page={currentPage}
      onPageChange={(event, page) => !loading && handlePagination(page)}
      rowsPerPage={limit}
      rowsPerPageOptions={[]}
    />
  );
}

const MarketplaceLogs = () => {
  const marketplaceLogs = useSelector((state) => state.marketplaceLogs);

  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const [filter, setFilter] = useState([]);

  const renderJsonField = ({ value }) => {
    return <ReactJson src={value} name={false} collapsed={true} sortKeys={true} />;
  };

  const handlePagination = (page) => {
    if (page < marketplaceLogs.currentPage) {
      dispatch(listMarketplaceLogs({ page: marketplaceLogs.currentPage - 1 }));
      dispatch({
        type: REDUX_ACTIONS.MARKETPLACE_LOGS_SET_CURRENT_PAGE,
        payload: marketplaceLogs.currentPage - 1
      });
    } else {
      dispatch(listMarketplaceLogs({ page: marketplaceLogs.currentPage + 1 }));
      dispatch({
        type: REDUX_ACTIONS.MARKETPLACE_LOGS_SET_CURRENT_PAGE,
        payload: page + 1
      });
    }
    apiRef.current.setFilterModel({
      items: filter
    });
    apiRef.current.scrollToIndexes({
      rowIndex: 0,
      colIndex: 0,
    });
  };

  useEffect(() => {
    if (filter.length === 0 && marketplaceLogs.data.length) {
      dispatch(listMarketplaceLogs());
    }
  }, [filter]);

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <Datagrid
          apiRef={apiRef}
          data={marketplaceLogs.data}
          columns={columns(renderCell, renderJsonField)}
          loading={marketplaceLogs.loading}
          disableStickyHeader={false}
          height={'90vh'}
          getRowId={(row) => row.grid_id}
          getRowHeight={() => 'auto'}
          autoPageSize={false}
          autoHeight={false}
          pagination={false}
          hideFooter
          experimentalFeatures={{ newEditingApi: true }}
          filterMode="server"
          onFilterModelChange={ (model) => {
            setFilter(model.items);
            const items = model.items.map(filter => {
              if (filter.field === 'userEmail' || filter.field === 'caller' || filter.field === 'payload') {
                return { ...filter, field: 'details.' + filter.field };
              } else {
                return filter;
              }
            });
            const filterModels = { ...model, items };
            dispatch({
              type: REDUX_ACTIONS.MARKETPLACE_LOGS_SET_FILTER,
              payload: filterModels.items.length ? filterModels : {}
            });
          }}
          sortingMode="server"
          onSortModelChange={(sortModel) => {
            const sort = sortModel.reduce((result, item) => {
              if (item.field === 'userEmail' || item.field === 'payload' || item.field === 'response') {
                result['details.' + item.field] = item.sort;
              } else if (item.field === 'orderNumber') {
                result['details.response.value.SaleOrder.OrderNum'] = item.sort;
              } else {
                result[item.field] = item.sort;
              }
              return result;
            }, {});
            dispatch({
              type: REDUX_ACTIONS.MARKETPLACE_LOGS_SET_SORT,
              payload: sort
            });
            dispatch({
              type: REDUX_ACTIONS.MARKETPLACE_LOGS_SET_CURRENT_PAGE,
              payload: 1
            });
            dispatch(listMarketplaceLogs());
          }}
          sx={{
            '.MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold !important',
            },
            [`& .${gridClasses.cell}`]: {
              py: 1,
            },
          }}
          toolbar={{
            options: {
              columns: true,
              filters: true,
              density: true,
              export: true,
            },
          }}
        />
        <CustomPagination
          currentPage={marketplaceLogs.currentPage - 1}
          limit={marketplaceLogs.limit}
          totalCount={marketplaceLogs.totalCount}
          handlePagination={handlePagination}
          loading={marketplaceLogs.loading}
        />
      </Grid>
    </Grid>
  );
};

MarketplaceLogs.propTypes = {
  row: PropTypes.object,
};

export default MarketplaceLogs;
